import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-react'
import { Textarea } from '@/components/ui/textarea'
import ColorPicker from './color-picker'
import { LocationPicker } from '@/components/location-picker'

// TODO remove duplicate interface
interface LatLng {
	lat: number
	lng: number
}

interface ProfileSectionProps {
	name: string | undefined
	onNameChange: (name: string) => void
	color: string
	onColorChange: (color: string) => void
	location: LatLng
	onLocationChange: (location: LatLng) => void
	introduction: string | undefined
	onIntroductionChange: (introduction: string) => void
	isSaving: boolean
	hasUnsavedChanges: boolean
	onSave: () => void
}

export function ProfileSection({
	name,
	onNameChange,
	color,
	onColorChange,
	location,
	onLocationChange,
	introduction,
	onIntroductionChange,
	isSaving,
	hasUnsavedChanges,
	onSave,
}: ProfileSectionProps) {
	const nameIsEmpty = !name?.trim()

	return (
		<>
			<div className="flex flex-col sm:flex-row gap-2 sm:gap-4 sm:items-start">
				<div className="w-full sm:w-32 sm:flex-shrink-0 sm:pt-2">
					<label className="block text-sm font-medium sm:text-end">Name</label>
				</div>
				<div className="w-full sm:w-64">
					<Input
						value={name || ''}
						onChange={(e) => onNameChange(e.target.value)}
						className="w-full"
						maxLength={20}
						aria-invalid={nameIsEmpty}
					/>
					{nameIsEmpty && (
						<p className="mt-1 text-sm text-rose-600">Name cannot be empty</p>
					)}
				</div>
			</div>

			<div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
				<div className="w-full sm:w-32 sm:flex-shrink-0">
					<label className="block text-sm font-medium sm:text-end">Color</label>
				</div>
				<ColorPicker
					value={color}
					onChange={onColorChange}
					className=""
				/>
			</div>

			<div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
				<div className="w-full sm:w-32 sm:flex-shrink-0">
					<label className="block text-sm font-medium sm:text-end">Location</label>
				</div>
				<div className="w-full">
					<LocationPicker
						location={location}
						setLocation={onLocationChange}
						className="w-full"
					/>
				</div>
			</div>

			<div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
				<div className="w-full sm:w-32 sm:flex-shrink-0">
					<label className="block text-sm font-medium sm:text-end">Introduction</label>
				</div>
				<Textarea
					value={introduction || ''}
					onChange={(e) => onIntroductionChange(e.target.value)}
					className="w-full"
					rows={6}
				/>
			</div>

			<div className="pt-2">
				<Button
					onClick={onSave}
					disabled={isSaving || !hasUnsavedChanges || nameIsEmpty}
					className="w-full"
				>
					{isSaving ? (
						<>
							<Loader2 className="mr-2 h-4 w-4 animate-spin" />
							Saving...
						</>
					) : (
						<>Save Profile</>
					)}
				</Button>
			</div>
		</>
	)
}
